module.exports = __webpack_public_path__ + "img/traditional-nautical-stars-mens-chest-and-shoulder-tattoos.jpg";